import ExhibitionEditForm from "./exhibition-edit-form";

export default ExhibitionEditForm;